import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemTrousers extends Item {
    constructor() {
        super(definitions.ITEM_ID.PRINCE_SVANS_TROUSERS, texture("prop_prince_svans_trousers_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }
}